import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLoaderData } from 'react-router-dom';

import { productRoute } from '.';
import { useStoreUrl } from '../../data/airthings-store';
import { PRODUCT_LEARN_MORE, PRODUCT_RECOMMEND_ME } from '../../data/analytics';
import { ProductData } from '../../data/products';
import Mixpanel from '../../mixpanel';

import styles from './Product.module.css';

type Props = {
  recommended?: boolean;
};

const Product = ({ recommended }: Props): JSX.Element => {
  const { t } = useTranslation();

  const product = useLoaderData() as ProductData;
  const storeUrl = useStoreUrl(product.shopUrl);

  useEffect(() => {
    const properties = Object.assign(
      { product: product.analyticsKey },
      recommended ? { recommended: true } : {}
    );

    Mixpanel.track_links(
      `.${styles.learnMore}`,
      PRODUCT_LEARN_MORE,
      properties
    );
  }, [product.analyticsKey, recommended]);

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: product.color,
      }}
    >
      <div
        className={styles.imageWrapper}
        style={{
          backgroundImage: `url(${product.imageUrl})`,
          boxShadow: `0 0 30px 30px ${product.color} inset`,
        }}
      />
      {!recommended && product.previous && (
        <Link
          className={styles.linkPrevious}
          to={productRoute(product.previous)}
        />
      )}
      {!recommended && product.next && (
        <Link className={styles.linkNext} to={productRoute(product.next)} />
      )}

      <div className={styles.drawer}>
        {recommended && (
          <p className={styles.recommended}>{t('Products.Recommended')}</p>
        )}
        <h1 className={styles.name}>{t(`${product.translationKey}.Name`)}</h1>
        <p className={styles.description}>
          {t(`${product.translationKey}.Description`)}
        </p>
        <a className={styles.learnMore} href={storeUrl}>
          {t('Products.LearnMore')}
        </a>
        {!recommended && (
          <p className={styles.recommend}>
            <Trans i18nKey="Products.Recommend">
              Need help?
              <Link
                className={styles.recommendLink}
                to={'../../wizard'}
                onClick={() =>
                  Mixpanel.track(PRODUCT_RECOMMEND_ME, {
                    product: product.analyticsKey,
                  })
                }
              >
                Recommend me a product
              </Link>
            </Trans>
          </p>
        )}
      </div>
    </div>
  );
};

export default Product;
